import React, { useState } from "react";
import { Box, Button, Modal, SpaceBetween, FormField, Multiselect, DatePicker  } from "@amzn/awsui-components-react";
import { createTasksFromTemplate } from "../../../phastos/components/phastosAPIs";
import {formatDate} from "../../utils/utils";
import {validateDataIngestionInput} from "../../utils/validationUtils";


export default function DataIngestionModal(props) {
    const {
        showDataIngestionModal,
        onDismiss,
        parentWorkflowId,
        reportingPeriod,
        dispatcher,
        ingestionSourceList = []
    } = props;

    const reportingStartDateStr = reportingPeriod.split(' - ')[0];
    const reportingStartDate = new Date(reportingStartDateStr);
    reportingStartDate.setHours(12);

    const [isError, setIsError] = React.useState(false);
    const [errorMsg, setErrorMsg] = React.useState("");
    const [startDate, setStartDate] = useState(formatDate(new Date(reportingStartDate)));
    const [endDate, setEndDate] = useState(formatDate(new Date()));
    const [ingestionSources, setIngestionSources] = useState([]);

    const ingestionSourceOptions = ingestionSourceList.map(source => ({
        value: source,
        label: source
    }));

    const onDismissHandler = () => {
        setStartDate(formatDate(new Date(reportingStartDate)));
        setEndDate(formatDate(new Date()));
        setIngestionSources([]);
        setIsError(false);
        setErrorMsg('');
        onDismiss();
    }

    const handleSubmit = () => {
        setIsError(false);
        setErrorMsg("");

        const { isValid, errors } = validateDataIngestionInput(startDate, endDate, ingestionSources);

        if (!isValid) {
            const firstError = errors.date || errors.ingestionSources || "Please provide valid dates and at least one ingestion source.";
            setIsError(true);
            setErrorMsg(firstError);
            return;
        }

        const requestPayload = {
            parentWorkflowId,
            startDate,
            endDate,
            ingestionSources
        };

        createTasksFromTemplate(requestPayload, dispatcher).then(() => {
            onDismissHandler();
        }).catch(err => {
            console.error("API call failed for Data Ingestion", err);
        });
    };



    return (
        <Modal
            visible={showDataIngestionModal}
            onDismiss={onDismissHandler}
            header="Data Ingestion"
            size="large"
            closeAriaLabel="Close dialog"
            footer={
                <Box float="right">
                    <SpaceBetween direction="horizontal" size="xs">
                        <Button variant="link" onClick={onDismissHandler}>Cancel</Button>
                        <Button variant="primary" onClick={handleSubmit}>Submit</Button>
                    </SpaceBetween>
                </Box>
            }
        >

            <SpaceBetween size="m" direction="vertical">
                {isError && (
                    <Box variant="p" color="text-status-error">
                        {errorMsg}
                    </Box>
                )}


                <FormField
                    label="Start Date*"
                    constraintText="Select the start date for ingestion"
                >
                    <DatePicker
                        onChange={({ detail }) => {
                            setIsError(false);
                            setStartDate(detail.value);
                        }}
                        value={startDate}
                        openCalendarAriaLabel={(selectedDate) =>
                            "Choose start date" +
                            (selectedDate ? `, selected date is ${selectedDate}` : "")
                        }
                        nextMonthAriaLabel="Next month"
                        placeholder="YYYY/MM/DD"
                        previousMonthAriaLabel="Previous month"
                        todayAriaLabel="Today"
                    />
                </FormField>

                <FormField
                    label="End Date*"
                    constraintText="Select the end date for ingestion"
                >
                    <DatePicker
                        onChange={({ detail }) => {
                            setIsError(false);
                            setEndDate(detail.value);
                        }}
                        value={endDate}
                        openCalendarAriaLabel={(selectedDate) =>
                            "Choose end date" +
                            (selectedDate ? `, selected date is ${selectedDate}` : "")
                        }
                        nextMonthAriaLabel="Next month"
                        placeholder="YYYY/MM/DD"
                        previousMonthAriaLabel="Previous month"
                        todayAriaLabel="Today"
                    />
                </FormField>

                <FormField label="Ingestion Source(s)*" constraintText="">
                    <Multiselect
                        selectedOptions={ingestionSourceOptions.filter(opt => ingestionSources.includes(opt.value))}
                        options={ingestionSourceOptions}
                        onChange={({ detail }) => {
                            setIsError(false);
                            setIngestionSources(detail.selectedOptions.map(opt => opt.value));
                        }}
                        placeholder="Select Ingestion Source(s)"
                        tokenLimit={3}
                    />
                </FormField>
            </SpaceBetween>

        </Modal>
    );
}
